<li class="header"><i class="fa fa-home"></i>Inicio</li>
<li class="nav-item">
  <a
    class="nav-link"
    routerLink="/"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: true }"
    >Dashboard</a
  >
</li>
<li *ngIf="userIsAuthenticated" class="nav-item">
  <a
    class="nav-link"
    routerLink="/ingredientes-condimentos"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: true }"
    >Ingredientes y condimentos</a
  >
</li>

<li class="header"><i class="fa fa-cutlery"></i>Platos</li>
<li *ngIf="userIsAuthenticated" class="nav-item">
  <a
    class="nav-link"
    routerLink="/platos"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: true }"
    >Listado</a
  >
</li>
<li *ngIf="userIsAuthenticated" class="nav-item">
  <a
    class="nav-link"
    routerLink="/platos/editar"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: true }"
    >Añadir nuevo</a
  >
</li>

<li class="header"><i class="fa fa-briefcase"></i>Neveras</li>
<li *ngIf="userIsAuthenticated" class="nav-item">
  <a
    class="nav-link"
    routerLink="/neveras"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: true }"
    >Listado</a
  >
</li>
<li *ngIf="userIsAuthenticated" class="nav-item">
  <a
    class="nav-link"
    routerLink="/neveras/editar"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: true }"
    >Añadir nueva</a
  >
</li>
<!--<
<li class="header"><i class="fa fa-black-tie"></i>Vestidos</li>
<!--<li *ngIf="userIsAuthenticated" class="nav-item">
  <a
    class="nav-link"
    routerLink="/neveras-despensas"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: true }"
    >Listado</a
  >
</li>-->
<!--
<li *ngIf="userIsAuthenticated" class="nav-item">
  <a
    class="nav-link"
    routerLink="/vestidos/editar"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: true }"
    >Añadir nuevo</a
  >
</li>-->

<li class="header" *ngIf="userIsAuthenticated && userRole == 'admin'">
  <i class="fa fa-users"></i>Usuarios/as
</li>
<li *ngIf="userIsAuthenticated && userRole == 'admin'" class="nav-item">
  <a class="nav-link" routerLink="/usuarios" [routerLinkActive]="['active']"
    >Gestionar usuarios/as</a
  >
</li>

<li class="header"><i class="fa fa-user"></i>Mi cuenta</li>
<li *ngIf="userIsAuthenticated" class="nav-item">
  <a class="nav-link" href="javascript:void(0);" (click)="onLogout()">
    Cerrar sesión
  </a>
</li>
